export { default } from './TierOverride';
export { default as reducer } from './TierOverride.ducks';
export { default as sagas } from './TierOverride.sagas';

import * as actions from './TierOverride.ducks';
export { actions };
